import type { Study, StudyArm } from '@bioavail/shared-types';
import {
  CalculationMode as CM,
  StudyType as ST,
  RouteOfAdministration as ROA,
  ArmRole as AR,
  AnalyteType as AT,
  ConcentrationUnit as CU,
  TimeUnit as TU,
  DoseUnit as DU,
  TrapezoidalRule as TR,
  BlqRule as BR,
  AucInterval as AI,
} from '@bioavail/shared-types';

let armCounter = 0;
let studyCounter = 0;

export function createArm(overrides: Partial<StudyArm> & { id?: string }): StudyArm {
  armCounter += 1;
  return {
    id: overrides.id ?? `arm-${armCounter}`,
    label: 'Untitled arm',
    route: ROA.Oral,
    role: AR.Test,
    dose: 100,
    doseUnit: DU.Mg,
    analyteType: AT.Parent,
    concentrationUnit: CU.NgPerMl,
    timeUnit: TU.Hour,
    dataPoints: [],
    usesDirectAuc: false,
    trapezoidalRule: TR.LinearUpLogDown,
    blqRule: BR.M1,
    lambdaZManualOverride: false,
    ...overrides,
  };
}

export function createStudy(overrides: Partial<Study> & { name: string }): Study {
  studyCounter += 1;
  const now = new Date().toISOString();
  return {
    id: overrides.id ?? `study-${studyCounter}`,
    mode: CM.Absolute,
    studyType: ST.SingleDose,
    arms: [
      createArm({ id: 'arm-test', role: AR.Test, label: 'Test arm' }),
      createArm({ id: 'arm-ref', role: AR.Reference, label: 'Reference arm' }),
    ],
    aucInterval: AI.ZeroToInf,
    createdAt: now,
    updatedAt: now,
    ...overrides,
  };
}
